export const FETCH_BATCH_ORDER_SUCCESS = 'FETCH_BATCH_ORDER_SUCCESS';
export const FETCH_BATCH_ORDER_REQUEST = 'FETCH_BATCH_ORDER_REQUEST';
export const FETCH_BATCH_ORDER_FAILURE = 'FETCH_BATCH_ORDER_FAILURE';
export const FETCH_BATCH_ORDER_REST = 'FETCH_BATCH_ORDER_REST';
export const fetchBatchOrderSuccess = (payload) => ({
    type: FETCH_BATCH_ORDER_SUCCESS,
    payload,
});
export const fetchBatchOrderRequest = (payload) => ({
    type: FETCH_BATCH_ORDER_REQUEST,
    payload,
});
export const fetchBatchOrderFailure = (payload) => ({
    type: FETCH_BATCH_ORDER_FAILURE,
    payload,
});
export const fetchBatchOrderReset = () => ({
    type: FETCH_BATCH_ORDER_REST,
});
